var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM13.3725 13.3625C12.9825 13.7525 12.3525 13.7525 11.9625 13.3625L9.8325 11.2325L7.7125 13.3525C7.3225 13.7425 6.6925 13.7425 6.3025 13.3525C5.9125 12.9625 5.9125 12.3325 6.3025 11.9425L8.4225 9.8225L6.2925 7.7025C5.9025 7.3125 5.9025 6.6825 6.2925 6.2925C6.6825 5.9025 7.3125 5.9025 7.7025 6.2925L9.8325 8.4125L11.9525 6.2925C12.3425 5.9025 12.9725 5.9025 13.3625 6.2925C13.7525 6.6825 13.7525 7.3125 13.3625 7.7025L11.2425 9.8225L13.3625 11.9425C13.7625 12.3325 13.7625 12.9725 13.3725 13.3625Z",
    fill: "#FF3333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.6665db5f92d2398cb4ad066ee38cf691.svg";
export { ForwardRef as ReactComponent };